// Dependencies
import CryptoJS from 'crypto-js';
/* eslint-disable no-mixed-operators */

/**
 * Function to take an ArrayBuffer and turn it into a CryptoJS WordArray.
 *
 * @see https://stackoverflow.com/a/33918579
 * @param {ArrayBuffer} arrayBuffer The ArrayBuffer to convert.
 * @returns {WordArray} The given arrayBuffer as a WordArray.
 */
function arrayBufferToWordArray(arrayBuffer) {
  let intArray = new Uint8Array(arrayBuffer);
  let array = [];
  for (var i = 0; i < intArray.length; i += 4) {
    array.push(intArray[i] << 24 | intArray[i + 1] << 16 | intArray[i + 2] << 8 | intArray[i + 3]);
  }

  return CryptoJS.lib.WordArray.create(array, intArray.length);
};
/* eslint-enable no-mixed-operators */

/**
 * Calculate the SHA256 hash of a given blob.
 *
 * @export
 * @param {any} blob
 * @returns {Promise} A promise that either resolves with the hex-encoded SHA hash, or rejects with an error.
 */
export default function calculateBlobSHA(blob) {
  return new Promise((resolve, reject) => {
    // If the blob isn't a valid instance of Blob, be sure to return early.
    if (!blob || !(blob instanceof Blob)) {
      return reject(new Error(`Given blob not instance of Blob, is ${typeof blob}`));
    }

    // Now, try to read the Blob contents as an array buffer.
    try {
      let reader = new FileReader();
      reader.onload = ((event) => {
        // Then, take the returned ArrayBuffer and convert it to a WordArray
        // for Crypto.js.
        let { result } = event.target;
        let wordArray = arrayBufferToWordArray(result);
        let hash = CryptoJS.SHA256(wordArray);

        // Finally, resolve with the calculated SHA256 hash encoded as a hex string.
        return resolve(hash.toString(CryptoJS.enc.Hex));
      });

      reader.readAsArrayBuffer(blob);
    } catch(e) {
      return reject(e);
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/calculate-blob-sha.js